"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APITemplateSupplier = void 0;
const HTMLEntityEncoder_1 = require("./HTMLEntityEncoder");
const rgxThousandSeparator = /(\d+)(\d{3})/;
class APITemplateSupplier {
    constructor(translations) {
        this.translations = translations;
        this.thousandSeparator = ",";
        this.decimalSeparator = ".";
        this.encoder = new HTMLEntityEncoder_1.HTMLEntityEncoder();
        if (this.translations) {
            this.translationsSection = this.translations.errors;
        }
    }
    setTranslations(translations) {
        if (typeof translations.locale === "object") {
            if (translations.locale.thousandSeparator) {
                this.thousandSeparator = translations.locale.thousandSeparator;
            }
            else {
                this.thousandSeparator = ",";
            }
            if (translations.locale.decimalSeparator) {
                this.decimalSeparator = translations.locale.decimalSeparator;
            }
            else {
                this.decimalSeparator = ".";
            }
        }
        this.translations = translations;
    }
    getThousandSeparator() {
        return this.thousandSeparator;
    }
    getDecimalSeparator() {
        return this.decimalSeparator;
    }
    htmlEntities(s) {
        return this.encoder.encode(s);
    }
    niceTimeInterval(ms) {
        const milliSeconds = ms % 1000;
        const seconds = Math.floor(ms % 60000 / 1000);
        const minutes = Math.floor(ms % 3600000 / 60000);
        const hours = Math.floor(ms / 3600000);
        let hmHours = this.niceInt(hours);
        if (hmHours.length < 2) {
            hmHours = "0" + hmHours;
        }
        return hmHours + ":"
            + ("0" + minutes).slice(-2) + ":"
            + ("0" + seconds).slice(-2) + ":"
            + ("00" + milliSeconds).slice(-3) + " (h:m:s:ms)";
    }
    getLocaleFloat(str) {
        str = str.replace(/\./i, this.decimalSeparator);
        while (rgxThousandSeparator.test(str)) {
            str = str.replace(rgxThousandSeparator, '$1' + this.thousandSeparator + '$2');
        }
        return str;
    }
    niceInt(n) {
        const value = (typeof (n) === "string") ? parseInt(n, 10) : n;
        if (isNaN(value) || Math.abs(value) < 999) {
            return value.toString();
        }
        let ret = value.toString();
        while (rgxThousandSeparator.test(ret)) {
            ret = ret.replace(rgxThousandSeparator, '$1' + this.thousandSeparator + '$2');
        }
        return ret;
    }
}
exports.APITemplateSupplier = APITemplateSupplier;
